/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_BLOCKED_SSNS, GET_BLOCKED_SSNS } from 'src/actions/blockedSsnActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const blockedSsnReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BLOCKED_SSNS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_BLOCKED_SSNS: {
      const { blockedSsns, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = blockedSsns;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default blockedSsnReducer;
